import axiosInstance from './axiosConfig';

// API endpoints
export const templeApi = {
  // Get Special Poojas
  getSpecialPoojas: () => 
    axiosInstance.get('/website/articles/type/Poojas/status/active'),
  
  // You can add other API calls here later
   getEvents: () => 
    axiosInstance.get('/website/articles/type/Event/status/active'),
   
  getServices: () => 
    axiosInstance.get('/website/articles/type/Services/status/active'),
};

// Test function to verify API connection
export const testApiConnection = async () => {
  try {
    const response = await templeApi.getSpecialPoojas();
    console.log('✅ API Connection Successful:', response.data);
    return response.data;
  } catch (error) {
    console.error('❌ API Connection Failed:', error);
    throw error;
  }
};

export default templeApi;